<script>
    import MobileNavbar from '../../reusableitems/mobileNavbar.svelte';
    import Mobilebtn from '../mobilebtn.svelte';
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';

    let main;
    let backClr;
    let text1;
    let text2;
    let text3;
    let mainImg;
    export let scrollPointers;
    export let updatedValue;

    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(
            main,
            scrollPointers,
            [
                {scrollValue: 5, duration: 1},
                {
                    scrollValue: 6,
                    duration: 1,
                    onUpdate: () => {
                        if (scrollPointers.scrollValue != 5 && scrollPointers.scrollValue != 6) {
                            updatedValue = scrollPointers.scrollValue;
                        }
                    },
                },
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            backClr,
            [
                {background: 'white', duration: 3},
                {background: '#FD0D5E', duration: 3},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            text1,
            [
                {bottom: 'max(38.785vw,17.956vh)', duration: 3},
                {bottom: 'max(22.43vw,10.384vh)', duration: 3},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            text2,
            [
                {left: '8.178vw', y: '-16vw', duration: 3},
                {left: '0vw', y: '0vw', duration: 3},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            text3,
            [
                {top: 'max(9vw,4.166vh)', duration: 3},
                {top: 'max(33.879vw,15.684vh)', duration: 3},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            mainImg,
            [
                {right: '0', duration: 3},
                {scale: '1.2', duration: 3},
            ],
            3,
        );
    }
</script>

<section bind:this={main}>
    <div class="navbar">
        <MobileNavbar />
    </div>
    <div class="main-div" bind:this={backClr}>
        <div class="text" bind:this={text3}><p>5</p></div>
        <div class="main-img" bind:this={mainImg}>
            <img
                src="images/Artist/ArtistMobile/virtualfashion.png"
                alt=""
                width="100%"
                height="100%"
            />
        </div>
        <div class="title" bind:this={text1}>
            <p bind:this={text2}>Virtual Fashion & Apparel Designers</p>
            <div class="descrip">
                <p>
                    For the first time ever, we’re giving fashion designers a
                    front row seat into the world of gaming and metaverse.
                </p>
                <p>
                    No longer will the characters be wearing skin tight
                    bodysuits (unless if that’s the fashion), rather it’s the
                    time to bring them equal to their human counterparts.
                </p>
                <p>
                    Our simulation technology enables clothes and accessories to
                    demonstrate near-to-real physics using state-of-the-art
                    technology. The future is here and you’re invited to be part
                    of it.
                </p>
            </div>
        </div>
        <div class="btn">
            <Mobilebtn bgcolor="rgba(253, 13, 95, 1)" width="56.308vw" state = "Artists & Musicians"/>

            <div class="div4">
                <p class="ar">></p>
            </div>
        </div>
    </div>
</section>

<style>
    .navbar {
        position: fixed;
        width: 100%;
        z-index: 3;
    }
    .main-div {
        width: 100%;
        height: max(216.355vw,100vh);
        position: relative;
        overflow: hidden;
        background-color: #fd0d5e;
    }
    .main-img {
        width: 100%;
        height: max(178.271vw,82.53vh);
        position: absolute;
        bottom: 0vw;
        right: -30vw;
    }
    .title {
        width: 60vw;
        position: absolute;
        left: 12.383vw;
        bottom: max(22.43vw,10.384vh);
        z-index: 2;
    }
    .title p {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 7.009vw;
        line-height: 7.009vw;
        text-transform: uppercase;
        color: #000000;
    }
    .descrip {
        width: 100%;
        text-align: left;
    }
    .descrip p:nth-child(1) {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 600;
        font-size: 2.804vw;
        text-transform: capitalize;
        color: white;
        letter-spacing: 6%;
        line-height: 3.364vw;
    }
    .descrip p:nth-child(2) {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 2.804vw;
        text-transform: capitalize;
        color: white;
        letter-spacing: 6%;
        line-height: 3.364vw;
    }
    .descrip p:nth-child(3) {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 2.804vw;
        text-transform: capitalize;
        color: white;
        letter-spacing: 6%;
        line-height: 3.364vw;
        margin: 0vw;
    }
    .btn {
        position: absolute;
        bottom: max(5.607vw, 2.592vh);
        left: max(21.495vw, 10.043vh);
    }
    .text {
        position: absolute;
        right: 33.178vw;
        top: max(33.879vw,15.684vh);
        width: 77.804vw;
        height: 93.458vw;
    }

    .text p {
        margin: 0;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 93.458vw;
        line-height: 100%;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: rgba(254, 86, 142, 0.2);
    }
    .div4 {
        height: 2.336vw;
        width: 5.841vw;
        margin: auto;
    }
    .ar {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 4.673vw;
        line-height: 5.841vw;
        letter-spacing: 0.06em;
        color: white;
        transform: rotate(90deg);
    }
</style>
